var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5C9.47 5 5 9.47 5 15C5 20.53 9.47 25 15 25C20.53 25 25 20.53 25 15C25 9.47 20.53 5 15 5ZM15 23C10.59 23 7 19.41 7 15C7 10.59 10.59 7 15 7C19.41 7 23 10.59 23 15C23 19.41 19.41 23 15 23ZM18.59 10L15 13.59L11.41 10L10 11.41L13.59 15L10 18.59L11.41 20L15 16.41L18.59 20L20 18.59L16.41 15L20 11.41L18.59 10Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseOutlined);
export default __webpack_public_path__ + "static/media/icon-close-outlined.3d3fd8f2769c1d27c01a23c096f19dec.svg";
export { ForwardRef as ReactComponent };